import { DropdownOption } from '../lib/Dropdown/types';
import {
  AttachedFile,
  ModificationTypes,
  PhRange,
  Prices,
  ProductApplications,
  TaxonomyWithKey,
  ValueOrNotApplicable,
} from './briefing';
import { ActiveIngredients } from './ingredients';

export type ApplicationWithLevel = {
  level: string;
  application: TaxonomyWithKey;
};

export type BriefingState = {
  branch?: Branch;
  steps: Step[];
  maxStepIndexAlreadyReached: number | null;
  productName: string | null;
  productApplications: ProductApplications;
  productApplicationsOther: string | null;
  productMarketingClaims: DropdownOption[] | null;
  productMarketingClaimsOther: string | null;
  formulationType: DropdownOption | null;
  texture: DropdownOption | null;
  storage: DropdownOption | null;
  productForm: DropdownOption | null;
  formulationTypeOther: string | null;
  textureOther: string | null;
  storageOther: string | null;
  productFormOther: string | null;
  requirementsMust: DropdownOption[] | null;
  requirementsMustOther: string | null;
  requirementsCan: DropdownOption[] | null;
  requirementsCanOther: string | null;
  restrictionsMust: DropdownOption[] | null;
  restrictionsMustOther: string | null;
  restrictionsCan: DropdownOption[] | null;
  restrictionsCanOther: string | null;
  requirementsApplicationConditionDetails: string | null;
  requirementsPHRange: PhRange;
  requirementsAggressiveComponents: string | null;
  requirementsLightStability: string | null;
  targetConsumerAge: string[] | null;
  targetConsumerGender: string | null;
  prices: Prices;
  additionalInfo: string | null;
  additionalInfoFiles: AttachedFile[] | null;
  problem: string | null;
  processingCapabilitiesPackagingDetails: ValueOrNotApplicable | null;
  packaging: DropdownOption | null;
  packagingOther: string | null;
  azelisRawMaterials: DropdownOption[];
  rawMaterial: string | null;
  activeIngredients: ActiveIngredients | null;
  activeFunctions: string[] | null;
  functionEmulsifier: DropdownOption[] | null;
  functionAdjuvant: DropdownOption[] | null;
  functionStabilizer: DropdownOption[] | null;
  functionSolvent: DropdownOption[] | null;
  functionLiquidColorant: DropdownOption[] | null;
  ingredientsFiles: AttachedFile[] | null;
  bakeStability: ValueOrNotApplicable | null;
  bakingTime: ValueOrNotApplicable | null;
  bakingTemperature: ValueOrNotApplicable | null;
  mixingStepDetails: ValueOrNotApplicable | null;
  productPh: ValueOrNotApplicable | null;
  brix: ValueOrNotApplicable | null;
  foodSafetyDetails: ValueOrNotApplicable | null;
  fillingTime: ValueOrNotApplicable | null;
  fillingTemperature: ValueOrNotApplicable | null;
  otherProcessingCapabilities: string | null;
  processingHotCold: ValueOrNotApplicable | null;
  homogenisation: ValueOrNotApplicable | null;
  finishedProductSamples: string | null;
  requiredSampleTime: string | null;
  finishedProductPotential: string | null;
  projectDeadline: string | null;
  colourShade: DropdownOption[] | string | null;
  colourSamples: string | null;
  colourRequiredTime: string | null;
  colourLabSupport: string | null;
  fragranceConcept: DropdownOption[] | null;
  fragranceDirection: DropdownOption[] | null;
  fragranceMust: DropdownOption[] | null;
  fragranceMustOther: string | null;
  fragranceCMR: string | null;
  fragranceMaxAmountAllergens: string | null;
  fragranceRequestedApplicationDosage: string | null;
  fragranceSamples: string | null;
  fragranceRequiredSampleTime: string | null;
  fragranceLargerSample: string | null;
  modifyBriefingType: ModificationTypes | null;
  modifyBriefingIssue: string | null;
};

export enum TrackingSchema {
  content = 'content',
  interaction = 'interaction',
  site = 'site',
  teaser = 'teaser',
  formulation = 'formulation',
  process = 'process',
  user = 'user',
  impersonator = 'impersonator',
}

export type Branch = 'create' | 'enhance' | 'modify' | 'fix';

export type Step =
  | 'application'
  | 'target-consumer'
  | 'formulation-attributes'
  | 'restrictions'
  | 'requirements'
  | 'colour'
  | 'price'
  | 'product-details'
  | 'fragrance'
  | 'additional-info'
  | 'review'
  | 'modification-type'
  | 'modification-issue'
  | 'problem'
  | 'ingredients'
  | 'active-ingredients'
  | 'active-function'
  | 'packaging'
  | 'processing-capabilities';

export type StepsByBranch = {
  [branch in Branch]: Step[];
};

export type Routes = { [key: string]: string };

export type RouteParams = { branch?: keyof StepsByBranch; step?: Step };

export type BriefingRoutes = {
  path: string;
  Component: React.FC<StepProps>;
  GTMTrackingData: {
    data: {
      category: string | undefined;
      type: string;
      content: string;
    };
    event: string;
    schema: TrackingSchema;
  };
}[];

export type StepProps = {
  mandatoryFields: MandatoryFieldDefinition;
  onValidate?: (isValid: boolean) => void;
};

export type MandatoryFieldDefinition = {
  [key: string]: (keyof BriefingState)[];
};
